import { WorldReady, DateTimeFormat } from '@paypalcorp/worldready';

const formatDate = ({ dateToFormat, country, language, timezone }) => {
  try {
    if (!dateToFormat) {
      return '';
    }

    const worldReady = new WorldReady(`${language}-${country.toUpperCase()}`);

    const shortDateFormatter = new DateTimeFormat(worldReady, {
      style: 'date-medium',
      timeZone: timezone,
    });
    return shortDateFormatter.format(new Date(dateToFormat));
  } catch (error) {
    return '';
  }
};

export default formatDate;
